export enum AbsenceStatus {
  Draft = 1,
  PendingApproval = 2,
  Accepted = 3,
  Rejected = 4,
  Cancelled = 5
}
